import {
  Component,
  OnInit,
  Inject,
  Optional,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MessageService } from 'src/app/common/services/message.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { HttpHeaders } from '@angular/common/http';

import { UtilService } from 'src/app/util/util.service';
import { ApiService } from 'src/app/common/services/api.service';
import { CommonService } from 'src/app/common/services/common.service';
import {
  catchError,
  debounceTime,
  filter,
  switchMap,
  tap,
} from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { EventTrackerService } from 'src/app/common/services/event-tracker.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrencyService } from 'src/app/util/currency.service';
import { FormaterService } from 'src/app/common/services/formater.service';
import { DateService } from 'src/app/common/services/date.service';
import { CROSS, MAP, LUNCH, LOYALITY_CUSTOMER } from 'src/defaultImages.js';
import { OrderEnum } from 'src/app/common/enums/order.enum';
import { LOYALTY_ENUMS } from 'src/app/common/enums/loyalty.enum';
import { LocalStorageService } from 'src/app/common/services/localStorage.service';
import { ORDER_BY } from 'src/app/order/platform.constant';
import { DynamicQrObj } from 'src/app/common/interfaces/dynamic-qr.interface';
import { SyncService } from 'src/app/common/services/sync-service.service';

@Component({
  selector: 'app-cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.css'],
})
export class CartModalComponent implements OnInit, AfterViewInit {
  images = { 
    CROSS: CROSS,
    MAP: MAP,
    LUNCH: LUNCH,
    LOYALITY_CUSTOMER
  }
  Currency;
  orderType = [];
  status: any;
  requesttype: string;
  actionAfterClose: string;
  selectedOrderTypeId: number;
  customerForm: FormGroup;
  allSections = [];
  selectedSection: string;
  selectedSectionName: string;
  selectedFloorTables = [];
  currentTitle: string;
  isTableChange = 0;
  modalState = {
    showOrderType: false,
    showCustomer: false,
    showTable: false,
    showEditPax: false,
    showPlatformOrderType: false,
  };
  selectedOrder = {
    id: null,
    name: '',
    platform: '',
  };
  currentUserId: string;
  showLoyaltyCashback: boolean = false;
  isLoyaltyLoading: boolean = false;
  loyaltyCashback: any = {};
  disableLoyaltyCheckbox: boolean = false;
  applyCashbackChecked: boolean = false;
  userId: string;
  isKiosk: number;
  isTransferTable: boolean = false;
  currentTableId: string;
  currentTableNo: string;
  buttonClicked: boolean = false;
  defaultValue: string = '';
  doesUserIdExist: boolean | null = null;
  loyaltyVisibleOnPOS: boolean = false;
  loyaltyAutoApply: boolean = false;
  isApiRequestLoading: boolean = false;
  requestFrom: any = 'cart';
  currentPax: any = 0;
  paxMandatory: any = 0;
  restSettings: any = {};
  isPlatformTypeDel = 0;
  isPlatformTypeTak = 0;
  gender:any = [{label:"Male",id:'M'},{label:"Female",id:'F'}]
  currPlatform = '';
  @ViewChild('calculator', { static: false }) input: ElementRef;
  customerSearch = {
    numberValidityStatus: '',
    nameValidityStatus: '',
    namePlaceHolder: 'Enter Name',
    genderValidityStatus : '',
    dobValidityStatus : ''
  };
  dynamicQrForm: FormGroup;
  translationText: any = {};
  subscription = new Subscription();
  currentDate = "";
  private customerDetailsSyncOrderId: string | null = null;
  private customerDetailsSubmitted = false;
  private customerDetailsCloseSynced = false;

  fetchedUserData = {
    name: '',
    gender: '',
    DOB: '',
    user_id: '',
    unique_id: '',
    special_category: null,
  };
  isPhoneNumLength13Chars: boolean = false;
  loyaltyErrorCondition: boolean = false;
  loyaltyTooltipText: string = '';
  loyaltyAmtReq: any = '';
  special_category = [
    { id: 'pelajar', name: 'Pelajar' },
    { id: 'oku', name: 'OKU' },
    { id: 'b40', name: 'B40' },
    { id: 'saudara_baru', name: 'Saudara Baru' },
    { id: 'warga_emas', name: 'Warga Emas' },
    { id: 'ibu_tunggal', name: 'Ibu Tunggal' },
  ];
  showSpecialFieldInUserForm: boolean;
  dynamicQrObj:DynamicQrObj = {
    minDynamicQrValidityLen:2,
    maxDynamicQrValidityLen:3,
    dynamicQrTableId:'',
    timeValidity:[],
    showDynamicQrSetting:false
  }

  constructor(
    public dialogRef: MatDialogRef<CartModalComponent>,
    public dialog: MatDialog,
    private messageService: MessageService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any = {},
    private fb: FormBuilder,
    private utilService: UtilService,
    private apiService: ApiService,
    private commonService: CommonService,
    private _eventTracker: EventTrackerService,
    public translateService: TranslateService,
    private curr: CurrencyService,
    private _localStorage: LocalStorageService,
    private _utilService: UtilService,
    private _dateService: DateService,
    private _formatService: FormaterService,
    private _syncService: SyncService
  ) {
    this.translateService.use(localStorage.getItem('language') || 'en_US');
    this.customerForm = this.fb.group({
      name: [''],
      dial_code: [localStorage.getItem('pos_dial_code'),Validators.pattern(/^\+[0-9]+$/)],
      number: [''],
      user_id: [''],
      user_gender:[''],
      user_dob:[''],
      unique_id: ['', [
        Validators.minLength(12),
        Validators.maxLength(12),
        Validators.pattern('^[a-zA-Z0-9]*$')
      ]],
      special_category: [null]
    });
    this.isKiosk = this.utilService.isKiosk();
    this.Currency = this.curr.getCurrency();
    this.showSpecialFieldInUserForm = this._utilService.showSpecialFieldInUserForm()
    this.setTransferTableData();
    const dynamicQrTimeFormat = this._utilService.getDynamicQrTimeMeasure();
    this.dynamicQrObj.minDynamicQrValidityLen = dynamicQrTimeFormat === 'hours' ? 1 : 2;
    this.dynamicQrObj.maxDynamicQrValidityLen = dynamicQrTimeFormat === 'hours' ? 2 : 3;
  }
  setTransferTableData() {
    if (this.data.transferTable && this.data.transferTable == true) {
      this.isTransferTable = true;
    } else this.isTransferTable = false;
    if (this.data.tableData) {
      this.selectedSection = this.data.tableData.floorid;
      this.selectedSectionName = this.data.tableData.floorname;
      this.currentTableId = this.data.tableData.tableid;
    }
  }
  ngOnInit() {
    this.subscription.add(
      this.translateService
        .get(['ORDER_DASHBOARD'])
        .subscribe((translation) => {
          this.translationText = translation.ORDER_DASHBOARD || {};
          this.customerSearch = {
            numberValidityStatus: '',
            nameValidityStatus: '',
            namePlaceHolder: this.translationText.NAME_PH,
            genderValidityStatus : '',
            dobValidityStatus : ''
          };
          this.gender = [
            { label: this.translationText.MALE, id: 'M' },
            { label: this.translationText.FEMALE, id: 'F' }
          ];
          this.dynamicQrObj.timeValidity= [
            {id:'minutes', label: this.translationText?.MINUTES},
            {id:'hours',label: this.translationText?.HOURS }
          ];
        })
    );
    this.currPlatform = localStorage.getItem('pos_platform');
    this.getOrderTypeListDetails();
    // this.orderType = this.utilService.get_pos_order_type();

    // this.get_tables()
    this.populateFloorDropdown();
    this.onFormControlValueChanges();

    this.status = this.data.status;
    this.requesttype = this.data.requesttype;
    this.actionAfterClose = this.data.actionAfterClose;
    this.requestFrom = this.data.requestFrom;
    try {
      this.restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      this.loyaltyVisibleOnPOS =
        this.restSettings['global']['loyalty_v2_visible_on_pos'];
      this.loyaltyAutoApply = this.loyaltyAutoApply =
        this.restSettings['global']['loyalty_auto_apply'];
    } catch (error) {
      this.loyaltyVisibleOnPOS = false;
    }

    if (this.status?.editPaxShow === 1) {
      this.currentTitle = this.translationText.ENTER_PAX;
      this.modalState['showEditPax'] = true;
      this.currentPax = this.data.currentPax;
      if (Number(this.currentPax) > 0) {
        this.defaultValue = this.currentPax;
      }
    } else if (this.status?.orderTypeShow === 1) {
      this.currentTitle = this.translationText?.SELECT_ORDER_TYPE;
      this.modalState['showOrderType'] = true;
    } else if (this.status?.userDetailShow === 1) {
      this.currentTitle = this.translationText.ENTER_CUSTOMER_DETAILS;
      this.modalState['showCustomer'] = true;
      this.setCustomerDetailsSyncState();
      const userId = localStorage.getItem('pos_user_id');
      if (
        userId &&
        !this.data.isLoyaltyApplied &&
        this.loyaltyVisibleOnPOS &&
        this.currPlatform == 'easyeat'
      ) {
        this.doesUserIdExist = true;
        this.fetchLoyaltyCashback(userId);
      }
    } else if(this.status?.tableShow && this.status?.dynamicQr){
      this.initDynamicQrForm();
    } else if (this.status?.tableShow === 1) {
      this.currentTitle = this.translationText.SELECT_TABLE;
      this.modalState['showTable'] = true;
    } else if (this.status?.platformOrderTypeShow === 1) {
      this.getPlatformDetailsByid(localStorage.getItem('pos_platform'));
      this.currentTitle =
        this.translationText?.SELECT_ORDER_TYPE +
        localStorage.getItem('pos_platform');
      this.modalState['showPlatformOrderType'] = true;
    }

    this.currentDate = localStorage.getItem('user_dob') ? this._dateService.getFormatedDate(localStorage.getItem('user_dob')) : '';
    if (localStorage.getItem('pos_no_enter') == '1') {
      this.customerForm.patchValue({
        name: localStorage.getItem('pos_username') || '',
        dial_code: localStorage.getItem('pos_dial_code'),
        number: localStorage.getItem('pos_number'),
        user_gender: localStorage.getItem('user_gender'),
        user_dob: localStorage.getItem('user_dob') ? this._dateService.getFormatedDate(localStorage.getItem('user_dob')) : '',
        user_id: localStorage.getItem('pos_user_id'),
        unique_id: localStorage.getItem('pos_unique_id'),
        special_category: localStorage.getItem('pos_special_category'),
      });
      const userName = localStorage.getItem('pos_username');
      if (userName !== 'Guest' && userName !== 'easyeat user') {
        this.customerForm.disable();
      }
    } else {
      this.customerForm.patchValue({
        name: localStorage.getItem('pos_username') || '',
        dial_code: localStorage.getItem('pos_dial_code'),
        user_gender: localStorage.getItem('user_gender'),
        user_dob: localStorage.getItem('user_dob') ? this._dateService.getFormatedDate(localStorage.getItem('user_dob')) : '',
        number: '',
      });
    }
    try {
      this.restSettings = JSON.parse(
        localStorage.getItem('restaurant_settings')
      );
      this.paxMandatory = this.restSettings['menu']['pax_mandatory'];
    } catch (error) {
      this.paxMandatory = 0;
    }
  }

  private setCustomerDetailsSyncState(): void {
    const restaurantId = localStorage.getItem('restaurant_id');
    const tokenOrOrderId = this.isKiosk
      ? this._localStorage.get('pos_order_id') ||
        this._localStorage.get('fc_cart_token')
      : this.data?.order_id || localStorage.getItem('cart_token');

    if (!restaurantId || !tokenOrOrderId) {
      return;
    }

    this.customerDetailsSyncOrderId = tokenOrOrderId;
    this.customerDetailsSubmitted = false;
    this.customerDetailsCloseSynced = false;
    this._syncService
      .setCustomerDetailsState(restaurantId, tokenOrOrderId)
      .subscribe(() => {}, () => {});
  }

  private closeCustomerDetailsSyncState(): void {
    if (this.customerDetailsCloseSynced || !this.customerDetailsSyncOrderId) {
      return;
    }
    const restaurantId = localStorage.getItem('restaurant_id');
    if (!restaurantId) {
      return;
    }
    this.customerDetailsCloseSynced = true;
    this._syncService
      .closeCustomerDetailsState(restaurantId, this.customerDetailsSyncOrderId)
      .subscribe(() => {}, () => {});
  }
  ngOnDestroy() {
    if (this.modalState?.showCustomer && !this.customerDetailsSubmitted) {
      this.closeCustomerDetailsSyncState();
    }
    this.subscription.unsubscribe();
  }
  ngAfterViewInit() {
    this.customerForm
      .get('number')
      .valueChanges.pipe(
        tap((i) => {
          (this.customerSearch.numberValidityStatus = null);
          this.checkPhoneLength13Chars(i);
        }),
        filter((i) => i.length >= 7),
        debounceTime(400),
        switchMap((searchTerm) =>
          this.getUserDetails(searchTerm).pipe(
            catchError((err) =>
              of({
                error: 'Not Found',
                message: this.translationText.NO_RECORD,
                statusCode: 404,
              })
            )
          )
        )
      )
      .subscribe((response: any) => {
        if (response.statusCode === 201) {
          this.fetchedUserData = response.data;
          this.customerSearch.numberValidityStatus = 'success';
          this.customerSearch.nameValidityStatus = null;
          this.customerSearch.namePlaceHolder = this.translationText.NAME_PH;
          this.customerForm.patchValue({
            name: (response.data || {}).name || '',
            user_id: response.data.user_id || '',
            user_gender: (response.data || {}).gender || '',
            user_dob: (response.data || {}).DOB || '',
            unique_id: '',
            special_category: null,
          });
          this.currentUserId = response.data.user_id;
          this.doesUserIdExist = true;
          if (this.loyaltyVisibleOnPOS && this.currPlatform == 'easyeat')
            this.fetchLoyaltyCashback(response.data.user_id);
        } else {
          this.fetchedUserData = {
            name: '',
            gender: '',
            DOB: '',
            user_id: '',
            unique_id:  '',
            special_category: null,
          };
          this.customerSearch.numberValidityStatus = null;
          this.customerSearch.nameValidityStatus = null;
          this.customerSearch.namePlaceHolder = this.translationText.NO_RECORD;
          this.customerForm.patchValue(
            { 
              name: '',
              user_id: '',
              user_gender: '',
              user_dob: '',
              unique_id: '',
              special_category: null,
            });
          setTimeout(() => {
            this.customerSearch.namePlaceHolder = this.translationText.NAME_PH;
          }, 2000);
          this.showLoyaltyCashback = false;
          this.currentUserId = '';
          this.doesUserIdExist = false;
        }
      });
  }
  initDynamicQrForm(){  
    this.modalState['showTable'] = true;
    this.currentTitle =  this.translationText?.GENERATE_DYNAMIC_QR;
    this.dynamicQrObj.showDynamicQrSetting = this._utilService.showDynamicQr();

    const dynamicQrValidity = this._utilService.getDynamicQrValidityTime();
    this.dynamicQrForm = this.fb.group({
      dynamicQrValidityTime: [
        this.convertDynamicQrTime(dynamicQrValidity),
        [
          Validators.required,
          Validators.pattern('^[1-9][0-9]*$'),
          Validators.minLength(this.dynamicQrObj?.minDynamicQrValidityLen),
          Validators.maxLength(this.dynamicQrObj?.maxDynamicQrValidityLen)
        ]
      ],
      dynamicQrTimeMeasure: this._utilService.getDynamicQrTimeMeasure()
    });
    const dynamicFormSubscription = this.dynamicQrForm?.get('dynamicQrTimeMeasure')?.valueChanges.subscribe((value) => {
      this.toggleQrTime(value);
    })
    this.subscription.add(dynamicFormSubscription);
  }
  toggleQrTime(event): void {
    const timeControl = this.dynamicQrForm?.controls?.dynamicQrValidityTime;
    const timeValidityControl = this.dynamicQrForm.get('dynamicQrValidityTime');
      
    if (event === 'minutes') {
      timeControl.setValue(30);
      this.dynamicQrObj.minDynamicQrValidityLen = 2;
      this.dynamicQrObj.maxDynamicQrValidityLen = 3;
    } else {
      timeControl.setValue(1);
      this.dynamicQrObj.minDynamicQrValidityLen = 1;
      this.dynamicQrObj.maxDynamicQrValidityLen = 2;
    }
  
    timeControl.clearValidators();
    timeValidityControl.setErrors(null);
    timeControl.setValidators([
      Validators.required,
      Validators.pattern('^[1-9][0-9]*$'), 
      Validators.minLength(this.dynamicQrObj?.minDynamicQrValidityLen),
      Validators.maxLength(this.dynamicQrObj?.maxDynamicQrValidityLen)
    ]);
  
    timeControl.updateValueAndValidity();  
  }
  trackById(item: any): number {
    return item.id;
  }
  handleQrValidityInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input?.value;
  
    value = value.replace(/[^0-9]/g, '');
  
    while(value.length > 0 && value[0] === '0') {
      value = value.slice(1);
    }
  
    if (value.length > this.dynamicQrObj?.maxDynamicQrValidityLen) {
      value = value.slice(0, this.dynamicQrObj?.maxDynamicQrValidityLen);
    }

    input.value = value;
    this.dynamicQrForm.patchValue({ dynamicQrValidityTime: value }, { emitEvent: true });
  }
  checkPhoneLength13Chars(i) {
    if(i.length === 13) {
      this.isPhoneNumLength13Chars = true;
      setTimeout(() => {
        this.isPhoneNumLength13Chars = false;
      }, 5000);
   }
 }

  onFormControlValueChanges() {
    // Extract form controls for easier reference
    const {
      special_category: specialCategoryControl,
      unique_id: uniqueIdControl,
      number: numberControl,
    } = this.customerForm.controls;

    // Helper function to add the required validator and update control validity
    const addRequiredValidator = (control, options = { onlySelf: true, emitEvent: false }) => {
      control.addValidators([Validators.required]);
      control.updateValueAndValidity(options);
    };

    // Helper function to remove the required validator and update control validity
    const removeRequiredValidator = (control) => {
      control.removeValidators([Validators.required]);
      control.updateValueAndValidity();
    };

    // Subscribe to changes in the special_category control
    specialCategoryControl.valueChanges.subscribe((value) => {
      if (value && value !== "null") {
        // Add required validator to unique_id control if unique_id is empty
        if (!uniqueIdControl.value) {
          addRequiredValidator(uniqueIdControl);
        }

        // Add required validator to number control if number is empty
        if (!numberControl.value) {
          addRequiredValidator(numberControl);
        }

        if(this.fetchedUserData.special_category){
          // Find the corresponding special category in fetchedUserData
          const valueInFetchUserData = (this.fetchedUserData.special_category || []).find((sc) => {
            return sc?.name?.toLowerCase() === value.toLowerCase();
          });
  
          // Patch the unique_id control with the found id or an empty string
          uniqueIdControl.patchValue(valueInFetchUserData ? valueInFetchUserData.id : '', { onlySelf: true, emitEvent: false });
        }
      }
    });

    // Subscribe to changes in the unique_id control
    uniqueIdControl.valueChanges.subscribe((value) => {
      if (value) {
        // Add required validators if unique_id has a value and the other controls are empty
        if (!specialCategoryControl.value) {
          addRequiredValidator(specialCategoryControl);
        }
        if (!numberControl.value) {
          addRequiredValidator(numberControl);
        }
      } else {
        // Remove required validators if unique_id is empty and the other controls are empty
        if (!specialCategoryControl.value) {
          removeRequiredValidator(specialCategoryControl);
        }
        if (!numberControl.value) {
          removeRequiredValidator(numberControl);
        }
      }
    });
  }


 getLoyaltyTooltipText(){
  if (this.loyaltyCashback.total_credits === 0) return this.loyaltyTooltipText = this.translationText.NO_CASHBACK_AVAILABLE;
  if (this.disableLoyaltyCheckbox) return this.loyaltyTooltipText = `${this.translationText.ADD_ITEMS_WORTH} ${this.Currency} ${this.loyaltyAmtReq} ${this.translationText.MORE_TO_APPLY}`;
  return this.loyaltyTooltipText = '';
 }

 getLoyaltyAmtReq(){
  if (this.data.order_id) {
    return this.loyaltyAmtReq = this.data?.minLoyaltyRedeem - this.data?.currOrder?.bill_amount;
  } else return this.loyaltyAmtReq = (this.data.currBill || {}).amt_req_redeem_loyalty_text || (this.data.fcCurrBill || {}).amt_req_redeem_loyalty_text;
 }
 
isLoyaltyRedeemable(data) {
  const invalidAmt = [undefined, 0]
  const hasNonZeroAmtReq = !invalidAmt.includes((data.currBill || {}).amt_req_redeem_loyalty || (data.fcCurrBill || {}).amt_req_redeem_loyalty);
  const itemTotalExists = data.itemTotal !== undefined
  const minRedeemExists = data.minLoyaltyRedeem !== undefined

  return hasNonZeroAmtReq || (itemTotalExists && minRedeemExists && data.itemTotal < data.minLoyaltyRedeem);
}

 getLoyaltyErrorCondition() {
  const loyaltyNotLoading = !this.isLoyaltyLoading;
  const hasNonZeroCredits = (this.loyaltyCashback || {}).total_credits !== 0;

  if (loyaltyNotLoading && hasNonZeroCredits && this.isLoyaltyRedeemable(this.data)) {
    return this.loyaltyErrorCondition = true;
  }
  
  this.loyaltyErrorCondition = false;
}

  isInputDifferentFromApiData() {
    const { special_category, unique_id } = this.customerForm.value;
    const fetchedSpecialCategories = this.fetchedUserData.special_category || [];
    const matchingCategory = fetchedSpecialCategories.find(
      (sc) => sc.name.toLowerCase() === (special_category || '').toLowerCase()
    );

    if (matchingCategory && matchingCategory.id !== unique_id) {
      return true;
    }

    if (!matchingCategory && (special_category || unique_id)) {
      return true;
    }

    return false;
  }


  isKioskUserDetailsNotValid(){
    return this.customerForm.get('number').value.length < 3 || this.customerForm.get('name').value.length < 3 || this.customerForm.get('dial_code').value === ''
  }

  fetchLoyaltyCashback(userId: string) {
    this.isLoyaltyLoading = true;
    this.getUserCredits(
      userId,
      localStorage.getItem('restaurant_id')
    ).subscribe((response: any) => {
      const { data } = response;
      this.loyaltyCashback = data;
      this.showLoyaltyCashback = true;
      this.isLoyaltyLoading = false;
      this.getLoyaltyAmtReq()
      this.getLoyaltyErrorCondition();
      if (
        data.total_credits !== 0 &&
        !this.isLoyaltyRedeemable(this.data)
      ) {
        this.disableLoyaltyCheckbox = false;
        if (this.loyaltyAutoApply) {
          this.applyCashbackChecked = true;
        } else {
          this.applyCashbackChecked = false;
        }
      } else {
        this.applyCashbackChecked = false;
        this.disableLoyaltyCheckbox = true;
      }

      if(this.loyaltyAmtReq <= 0){
        this.applyCashbackChecked = true;
        this.loyaltyErrorCondition = false;
        this.disableLoyaltyCheckbox = false;
      }

      if(this.loyaltyAmtReq > 0 && typeof this.loyaltyAmtReq === 'number'){
        this.loyaltyAmtReq = this._formatService.formatNo(this.loyaltyAmtReq);
      }
      
      this.getLoyaltyTooltipText();
    });
  }

  getUserCredits(userId: string, restaurantId: string) {
    return this.apiService.getWallet(userId, restaurantId);
  }

  getUserDetails(searchTerm) {
    this.fetchedUserData = {
      name: '',
      gender: '',
      DOB: '',
      user_id: '',
      unique_id: '',
      special_category: null,
    };
    this.customerSearch.numberValidityStatus = null;
    this.customerSearch.nameValidityStatus = 'validating';
    this.customerSearch.namePlaceHolder = this.translationText.SEARCHING;
    this.customerForm.patchValue(
      { 
        name: '',
        user_id: '',
        user_gender: '',
        user_dob: '',
        unique_id: '',
        special_category: null,
      });
    const payload = {
      dial_code: this.customerForm.get('dial_code').value,
      phone: searchTerm,
    };
    return this.apiService.getUserDetailsByContact(payload);
  }
  getNumber(number) {
    if (Number(this.input.nativeElement.value + number) > 0) {
      this.input.nativeElement.value += number;
    }
    this.defaultValue = this.input.nativeElement.value;
  }

  numBack(e) {
    this.input.nativeElement.value = this.input.nativeElement.value.substr(
      0,
      this.input.nativeElement.value.length - 1
    );
  }
  changes(e) {
    if (this.defaultValue == '') {
      return e.charCode > 48 && e.charCode <= 57;
    } else {
      return e.charCode >= 48 && e.charCode <= 57;
    }
  }

  savePaxClicked() {
    const askCustomerInfo = !!(JSON.parse(this._localStorage.get('restaurant_settings')?.global?.cust_info_popup || '0'));
    if (this.paxMandatory && this.defaultValue == '') {
      this.messageService.info('pax is mandatory');
    } else if (this.requestFrom == 'order') {
      let order_id = this.data.order_id;
      if (Number(this.data.order_type) == 0 && this.defaultValue == '') {
        this.defaultValue = '1';
      }
      const payload = {
        order_id: order_id,
        fields: {
          pax: Number(this.defaultValue),
        },
      };
      this.apiService.updateOrderDetails(payload).subscribe(
        (response) => {
          if (response.statusCode == 201) {
            this.dialogRef.close({ success: 1 });
          } else {
            this.dialogRef.close({ success: 0 });
          }
        },
        (error) => {
          this.dialogRef.close({ success: 0 });
        }
      );
    } else {
      localStorage.setItem('pos_order_pax_set', '1');
      localStorage.setItem('pos_order_pax', this.defaultValue);
      let topic = 'cart_user_details';
      let orderInfo = {
        orderType: this.selectedOrder.id,
        user: this.customerForm.value,
        table: {
          tableno: 'dl',
          tableid: 'dl',
        },
        platform: this.selectedOrder.platform,
        pax: Number(this.defaultValue),
      };
      if (!askCustomerInfo) {
        orderInfo['table']['tableid'] = this._localStorage.get('pos_table_id');
        orderInfo['table']['tableno'] = this._localStorage.get('pos_table_no');
      }
      if (this.actionAfterClose == 'self') {
        topic = 'cart_user_details';
        this.dialogRef.close({});
      } else if (
        this.actionAfterClose == 'cart' ||
        this.actionAfterClose == 'settle'
      ) {
        if (this.status.userDetailShow === 1) {
          this.currentTitle = this.translationText.ENTER_CUSTOMER_DETAILS;
          this.modalState['showCustomer'] = true;
          this.modalState['showEditPax'] = false;
          this.modalState['showTable'] = false;
          this.modalState['showOrderType'] = false;
        } else if (this.status.tableShow === 1) {
          this.currentTitle = this.translationText.SELECT_TABLE;
          this.modalState['showEditPax'] = false;
          this.modalState['showTable'] = true;
          this.modalState['showCustomer'] = false;
          this.modalState['showOrderType'] = false;
        } else if (
          this.status.userDetailShow === 0 &&
          this.status.tableShow === 0
        ) {
          this.userDetailsClicked(orderInfo);
        } else {
          topic = 'update_required_field';
          this.dialogRef.close({
            topic: 'cart_order_type',
            data: orderInfo,
            type: this.requesttype,
            actionAfterClose: this.actionAfterClose,
          });
        }
      }
    }
  }
  printDynamicQr():void{
    if(this.dynamicQrForm?.invalid){
      const timeMeasure = this.dynamicQrForm?.get('dynamicQrTimeMeasure')?.value;
      const errorText = timeMeasure === 'hours' ? this.translationText?.MINIMUM_DYNAMIC_QR_TIME_HOURS : this.translationText?.MINIMUM_DYNAMIC_QR_TIME_MINUTES
      this.messageService.showError(errorText);
      return;
    }
    if(!this.dynamicQrObj?.dynamicQrTableId){
      return;
    }
    const qrValidityTime = this.convertDynamicQrTimeInSec(this.dynamicQrForm?.get('dynamicQrValidityTime')?.value);
    const printQrObj = {
      expiryTime: qrValidityTime,
      tableId: this.dynamicQrObj?.dynamicQrTableId,
      tableNo: this.currentTableNo
    }
    this._utilService.sendDynamicQrPrintCommand(printQrObj);
  }
  convertDynamicQrTimeInSec(time):number{
    let dynamicQrTime = time;
    if(this.dynamicQrForm?.get('dynamicQrTimeMeasure')?.value === 'hours'){
      dynamicQrTime  = dynamicQrTime * 3600;
    }else{
      dynamicQrTime = dynamicQrTime * 60;
    }
    return dynamicQrTime;
  }
  convertDynamicQrTime(time):number{
    const timeMeasure = this._utilService.getDynamicQrTimeMeasure();
    let dynamicQrTime = time;
    if(timeMeasure === 'minutes'){
      dynamicQrTime = time/60;
    }
    else{
      dynamicQrTime = time/3600;
    }
    return dynamicQrTime;
  }

  setPlatformOrderTypeClicked(type) {
    if (type == 1) {
      this.selectedOrder.id = 1;
    } else {
      this.selectedOrder.id = 2;
    }
    let topic = 'platform_order_type_updated';
    let orderInfo = {
      orderType: this.selectedOrder.id,
      user: this.customerForm.value,
      table: {
        tableno: type === 2 ? 'takeaway' : 'dl',
        tableid: type === 2 ? 'takeaway' : 'dl',
      },
      platform: this.selectedOrder.platform,
    };
    localStorage.setItem('pos_table_id', orderInfo.table.tableid);
    localStorage.setItem('pos_table_no', orderInfo.table.tableno);
    this.dialogRef.close({
      topic: topic,
      data: orderInfo,
      type: this.requesttype,
      actionAfterClose: this.actionAfterClose,
    });
  }
  getPlatformDetailsByid(platform_id) {
    this.apiService
      .getOfflinePlatformDetails(
        platform_id,
        localStorage.getItem('restaurant_id')
      )
      .subscribe((res) => {
        if (res.statusCode == 200) {
          this.patchValues(res);
        }
      });
  }
  patchValues(res) {
    if (res.data.order_type == 3) {
      this.isPlatformTypeDel = 1;
      this.isPlatformTypeTak = 1;
    } else if (res.data.order_type == 2) {
      this.isPlatformTypeDel = 0;
      this.isPlatformTypeTak = 1;
    } else if (res.data.order_type == 1) {
      this.isPlatformTypeDel = 1;
      this.isPlatformTypeTak = 0;
    }
  }

  getOrderTypeListDetails() {
    // Same approach as order-type modal: use cached restaurant details (no blocking API).
    const applyFromRestaurantData = (data) => {
      if (!data) {
        return;
      }
      const orderTypeList = this.utilService.prepareOrderTypeList(
        (data || {}).offline_platforms
      );
      this.orderType = this.utilService.get_pos_order_type(orderTypeList);
      try {
        if (parseInt(data?.settings?.print?.on_table_change) > 0) {
          this.isTableChange = 1;
        }
      } catch (error) {
        this.isTableChange = 0;
      }
    };

    // Populate synchronously before first paint when data is already in memory.
    applyFromRestaurantData(this.commonService.restaurantDetails$.value);
    if (!this.orderType?.length) {
      try {
        const raw = JSON.parse(
          this._localStorage.get('restaurant_details') || '{}'
        );
        applyFromRestaurantData(raw?.data || raw);
      } catch {}
    }

    this.subscription.add(
      this.commonService.getRestaurantDataObs().subscribe((data) => {
        applyFromRestaurantData(data);
      })
    );
  }
  cancel_clicked() {
    if (this.modalState?.showCustomer && !this.customerDetailsSubmitted) {
      this.closeCustomerDetailsSyncState();
    }
    let customObj: Record<any, any> = { data: 'closed' };

    if (this.applyCashbackChecked) {
      const orderInfo = {
        orderType: this.selectedOrder.id,
        user: this.customerForm.value,
        table: {
          tableno: 'dl',
          tableid: 'dl',
        },
        platform: this.selectedOrder.platform,
      };

      customObj = {
        topic: 'custom_loyalty_applied',
        data: orderInfo,
        type: 'self',
        actionAfterClose: 'self',
      };
    }

    this.dialogRef.close(customObj);
  }

  orderTypeClicked(item) {
    // this.selectedOrderTypeId = item.id;
    this.selectedOrder.id = item.id;
    this.selectedOrder.name = item.name;
    this.selectedOrder.platform = item.platform;
    let orderInfo = {
      orderType: this.selectedOrder.id,
      user: this.customerForm.value,
      table: {
        tableno: item.order_type === 2 ? 'takeaway' : 'dl',
        tableid: item.order_type === 2 ? 'takeaway' : 'dl',
      },
      platform: this.selectedOrder.platform,
    };
    localStorage.setItem('pos_order_type_set', '1');
    localStorage.setItem('pos_platform_order_type', item.id);
    localStorage.setItem('pos_table_id', orderInfo.table.tableid);
    localStorage.setItem('pos_table_no', orderInfo.table.tableno);
    this.dialogRef.close({
      topic: 'cart_order_type',
      data: orderInfo,
      type: this.requesttype,
      actionAfterClose: this.actionAfterClose,
    });

    this._eventTracker.easyeat_track_event('ORDER_TYPE_SELECTED', {
      'Order Source': 'POS',
      'Order Type': this.selectedOrder.id,
      'Order Platform': this.selectedOrder.platform,
    });
  }

  handleCashbackCheckbox(event) {
    this.applyCashbackChecked = event.target.checked;
  }

  userDetailsDialogCloseHandler(topic, orderInfo) {
    this.customerDetailsSubmitted = true;
    localStorage.setItem('pos_user_details_set', '1');
    if (this.actionAfterClose == 'self') {
      topic = 'cart_user_details';
      this.dialogRef.close({
        topic: topic,
        data: orderInfo,
        type: this.requesttype,
        actionAfterClose: this.actionAfterClose,
      });
    } else if (
      this.actionAfterClose == 'cart' ||
      this.actionAfterClose == 'settle'
    ) {
      if (this.status.tableShow === 1) {
        this.currentTitle = this.translationText.SELECT_TABLE;
        this.modalState['showTable'] = true;
        this.modalState['showCustomer'] = false;
      } else {
        topic = 'update_required_field';
        this.dialogRef.close({
          topic: topic,
          data: orderInfo,
          type: this.requesttype,
          actionAfterClose: this.actionAfterClose,
        });
      }
    }
  }

  userDetailsClicked(orderDetails=null) {
    let topic = 'cart_user_details';
    this.customerForm.markAllAsTouched();
    
    // Check if this is a "Skip" action (minimal customer details)
    const isSkipAction = !((this.customerForm.get('number').value.length === 0 ||
      this.customerForm.get('number').value.length > 8) &&
      this.customerForm.get('name').value.length > 0) && !this.isKiosk;
    
    // Trigger syncService for Customer Skip
    if (isSkipAction && this.customerDetailsSyncOrderId) {
      const restaurantId = localStorage.getItem('restaurant_id');
      if (restaurantId) {
        this._syncService
          .syncCustomerSkipState(restaurantId, this.customerDetailsSyncOrderId, true)
          .subscribe(() => {}, () => {});
      }
    }
    
    if (this.customerForm.valid || this.doesUserIdExist) {
      let orderInfo = {
        orderType: this.selectedOrder.id,
        user: this.customerForm.value,
        table: {
          tableno: 'dl',
          tableid: 'dl',
        },
        platform: this.selectedOrder.platform,
      };
      if (orderDetails) {
        orderInfo = orderDetails;
      }
      if (this.isInputDifferentFromApiData() && this.doesUserIdExist) {
        const payload = {
          user_id: this.currentUserId,
          fields: {
            special_category: [
              {
                name: this.customerForm.value.special_category,
                id: this.customerForm.value.unique_id,
              },
            ],
          },
        };
        this.apiService.updateUserDetails(payload).subscribe(
          (response) => {
          },
          (error) => {
            console.log(error);
          }
        );
      }

      if (this.applyCashbackChecked) {
        this.isApiRequestLoading = true;

        const redeemLoyaltyParams = this.getRedeemLoyaltyParams();
        const apiServiceMethod = this.data.order_id
          ? this.apiService.redeemLoyaltyOnOrder.bind(this.apiService)
          : this.isKiosk ? this.apiService.redeemLoyaltyOnCartFC.bind(this.apiService) : this.apiService.redeemLoyaltyOnCart.bind(this.apiService);
        const callBack = this.data.order_id
          ? () => this.dialogRef.close({message:LOYALTY_ENUMS.LOYALTY_APPLIED_ON_ORDER})
          : () => this.userDetailsDialogCloseHandler(topic, orderInfo);
          
        this.callApiService(apiServiceMethod, redeemLoyaltyParams, callBack);
      } else {
        this.userDetailsDialogCloseHandler(topic, orderInfo);
      }
    }

    this._eventTracker.easyeat_track_event('CUSTOMER_DETAILS_SAVED', {
      'Order Source': 'POS',
      'CUSTOMER NAME': this.customerForm.value.name,
      'DIAL CODE': this.customerForm.value.dial_code,
      'CUSTOMER MOBILE NUMBER': this.customerForm.value.number,
      'GENDER': this.customerForm.value.user_gender,
      'USER DOB': this.customerForm.value.user_dob,
      'USER_UNIQUE_ID': this.customerForm.value.unique_id,
      'USER_SPECIAL_CATEGORY': this.customerForm.value.special_category,
    });

    this._eventTracker.easyeat_track_event('CUSTOMER_DETAILS_SAVED', {
      'DIAL CODE': this.customerForm.value.dial_code || 'N/A',
      'CUSTOMER MOBILE NUMBER': this.customerForm.value.number || 'N/A',
      'GENDER': this.customerForm.value.user_gender || 'N/A',
      'USER DOB': this._dateService.getFormatedDate(this.customerForm.value.user_dob)|| 'N/A',
      'USER_UNIQUE_ID': this.customerForm.value.unique_id,
      'USER_SPECIAL_CATEGORY': this.customerForm.value.special_category,
    });

  if( this.data && this.data.order_id){
    const payload = {
      order_id: this.data.order_id,
      fields: {
        dial_code: this.customerForm.value.dial_code,
        phone: this.customerForm.value.number,
        name: this.customerForm.value.name,
        user_gender: this.customerForm.value.user_gender,
        user_dob: this.customerForm.value.user_dob
          ? this._dateService.getFormatedDate(this.customerForm.value.user_dob)
          : '',
        ...(this.fetchedUserData.user_id && {
          user_id: this.fetchedUserData.user_id,
        }),
        user_unique_id: this.customerForm.value.unique_id,
        user_special_category: this.customerForm.value.special_category
      },
    };
    this.apiService.updateCustomerDetails(payload).subscribe(
      (response) => {
        this.customerDetailsSubmitted = true;
        if (!this.applyCashbackChecked){
          this.dialogRef.close({
            data: OrderEnum.USER_DETAILS_CLICKED,
            success: 1,
          });
        }
      },
      (error) => {
        if (!this.applyCashbackChecked){
          this.dialogRef.close({
            data: OrderEnum.USER_DETAILS_CLICKED,
            success: 0,
          });
        }
        console.log(error);
      }
    );
  }

  }

  getRedeemLoyaltyParams() {
    const commonParams = {
      action: LOYALTY_ENUMS.APPLY,
      full_redeem: true,
      user_id: this.currentUserId || this._localStorage.get('pos_user_id'),
    };
  
    if (this.data.order_id) {
      return {
        ...commonParams,
        order_id: this.data.order_id,
      };
    } else if (this.isKiosk){
      return {
        ...commonParams,
        cart_token: this._localStorage.get('fc_cart_token'),
        source: ORDER_BY.MM,
        foodcourt: this._localStorage.get('restaurant_nameid'),
        order_type: Number(this._localStorage.get('pos_order_type')),
      }; 
    } else {
      return {
        ...commonParams,
        cart_token: localStorage.getItem('cart_token'),
        source: ORDER_BY.MM,
      };
    }
  }

  callApiService(apiServiceMethod, redeemLoyaltyParams, callBack) {
  apiServiceMethod(redeemLoyaltyParams).subscribe((response) => {
    this.isApiRequestLoading = false;
    if (response.statusCode === 200) {
      this.messageService.showSuccess(
        this.translationText.LOYALTY_CASHBACK_APPLIED
      );
      if(callBack) callBack()
    }
  },
  (error) => {
    this.isApiRequestLoading = false;
    this.messageService.showError(
      this.translationText.LOYALTY_CANNOT_APPLIED + ': ' + error.error.message.join(', ')
    );
    if(callBack) callBack()
    console.log(error);
  }
  );
}

  tableClicked(tableNo, tableId) {
    this.currentTableNo = tableNo;
    this.dynamicQrObj.dynamicQrTableId = tableId;

    if (!this.isTransferTable) {
      let topic = 'cart_table_clicked';
      let orderInfo = {
        orderType: this.selectedOrder.id,
        user: this.customerForm.value,
        platform: this.selectedOrder.platform,
        table: {
          tableno: tableNo,
          tableid: tableId,
        },
      };
      localStorage.setItem('pos_table_no_set', '1');
      if (this.actionAfterClose == 'self') {
        topic = 'cart_table_clicked';
        this.dialogRef.close({
          topic: topic,
          data: orderInfo,
          type: this.requesttype,
          actionAfterClose: this.actionAfterClose,
        });
      } else if (
        this.actionAfterClose == 'cart' ||
        this.actionAfterClose == 'settle'
      ) {
        topic = 'update_required_field';
        this.dialogRef.close({
          topic: topic,
          data: orderInfo,
          type: this.requesttype,
          actionAfterClose: this.actionAfterClose,
        });
      }

      this._eventTracker.easyeat_track_event('TABLE_NUM_SELECTED', {
        'Order Source': 'POS',
        FLOOR_NAME: this.selectedSectionName,
        TABLE_NUM: tableNo,
      });

      this._eventTracker.easyeat_track_event('TABLE_NUM_SELECTED', {
        TABLE_NUM: tableNo,
      });
    } else {
      this.currentTableId = tableId;
    }
  }

  // findSelectedFloorTables(floorid){
  //   for( let item of this.allSections){
  //     if(item.floor_id === floorid){
  //       this.selectedFloorTables = item.tables;
  //       break;
  //     }
  //   }
  // }
  // change(id){
  //   this.findSelectedFloorTables(id);
  // }
  changeFloor(id, name) {
    this.selectedSection = id;
    this.selectedSectionName = name;
  }
  transferTable_clicked() {
    this.buttonClicked = true;
    let httpOptions: { headers } = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${
          this.data.roles_token
            ? this.data.roles_token
            : localStorage.getItem('token')
        }`,
      }),
    };
    const payload = {
      token: this.data.roles_token
        ? this.data.roles_token
        : localStorage.getItem('token'),
      order_id: this.data.order_id,
      table_id: this.currentTableId,
    };
    this.apiService.updateTablenoOfOrder(payload, httpOptions).subscribe(
      (response: any) => {
        if (response.statusCode == 201) {
          if (this.isTableChange) {
            this.utilService.sendTransferTableComand(this.data.order_id);

            this._eventTracker.easyeat_track_event('COMPLETED_TABLE_TRANSFER', {
              User_name: localStorage.getItem('user_name'),
              Restaurant_ID: localStorage.getItem('restaurant_id'),
              Restaurant_Name: localStorage.getItem('restaurant_nameid'),
              User_role: localStorage.getItem('ee_user_type'),
              ORDER_ID: this.data.order_id,
              NEW_TABLE: this.currentTableNo,
            });
          }
          this.messageService.showSuccess(response.data.message);
          this.dialogRef.close({ data: 'tableno changed', success: 1 });
          this.buttonClicked = false;
        } else this.buttonClicked = false;
      },
      (error) => {
        this.messageService.showError(error.error.message);
        this.dialogRef.close({ data: '', sucess: 0 });
        this.buttonClicked = false;
      }
    );
  }

  availableFloors: Array<any> = [];
  fetchingTablesData: boolean = true;
  private withoutDeleted(items: any[]): any[] {
    return (items || []).filter((item) => Number(item?.status) !== 9);
  }

  populateFloorDropdown() {
    this.apiService.getAllAvailableFloorsAndTables(null, 1).subscribe(
      (response) => {
        this.availableFloors = this.withoutDeleted(
          (response['data'] || {}).floors || []
        );
        for (let i = 0; i < this.availableFloors.length; i++) {
          // restrict delivery/takeaway floor in dropdown (select table modal)
          if (this.availableFloors[i].floor_id === 'dlf') {
            this.availableFloors.splice(i, 1);
            break;
          }
        }
        this.selectedSection = this.availableFloors.length
          ? (this.availableFloors[0] || {})['floor_id']
          : null;
        this.selectedSection && this.getTablesData();
      },
      (error) => {
        this.messageService.showError(
          (error['error'] || {}).message ||
            this.translationText.SOMETHING_WENT_WRONG
        );
      }
    );
  }
  disableFutureDates = (current: Date): boolean => {
    // Get today's date
    const today = new Date();

    // Disable dates in the future (including today)
    return current > today;
  }
  getTablesData() {
    this.fetchingTablesData = true;
    this.apiService
      .getAllAvailableFloorsAndTables(null, 0, this.selectedSection)
      .subscribe(
        (response) => {
          this.selectedFloorTables = this.withoutDeleted(
            (response['data'] || {}).tables || []
          );
          this.fetchingTablesData = false;
        },
        (error) => {
          this.fetchingTablesData = false;
          this.messageService.showError(
            (error['error'] || {}).message ||
              this.translationText.SOMETHING_WENT_WRONG
          );
        }
      );
  }
  checkInput(ev, type) {
    if (type === 'dial_code' && !/^\+[0-9]+$/.test(ev.target.value)) {
      if (!ev?.target?.value) {
        this.customerForm.get('dial_code').setValue('+');
      }
    } else if (
      (type === 'name' && !/^[A-Za-z\s]*$/.test(ev.target.value)) ||
      (type === 'phone' && !/^[0-9]*$/.test(ev.target.value))
    ) {
      ev.target.value = null;
    }
  }

  disabledDate = (current: Date): boolean => {
    return this._dateService.isFutureDate(current);
  };
}
